import React, { useState, useEffect } from "react";
import "../assets/css/animatedHeadline.css";
import { useTranslation } from "react-i18next";


const typingSpeed = 150; // Vitesse de frappe
const erasingSpeed = 75; // Vitesse d'effacement
const delayBetweenWords = 1000; // Temps avant de changer de mot

function AnimatedHeadline() {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  const words = [t("AWS_ARCHITECT"), t("DEVELOPER"), t("FinOps_ENGINEER"), t("AWS_DEVOPS")];

  useEffect(() => {
    let timeout;

    if (isDeleting) {
      if (displayedText.length > 0) {
        timeout = setTimeout(() => {
          setDisplayedText((prev) => prev.slice(0, -1));
        }, erasingSpeed);
      } else {
        setIsDeleting(false);
        setCurrentIndex((prev) => (prev + 1) % words.length);
      }
    } else {
      if (displayedText.length < words[currentIndex].length) {
        timeout = setTimeout(() => {
          setDisplayedText(words[currentIndex].slice(0, displayedText.length + 1));
        }, typingSpeed);
      } else {
        timeout = setTimeout(() => setIsDeleting(true), delayBetweenWords);
      }
    }

    return () => clearTimeout(timeout);
  }, [displayedText, isDeleting, currentIndex]);

  return (
    <h1 className="ah-headline">
      <span>{t("AnimatedHeadline")}</span> 
      <span className="ah-words-wrapper"><i>{displayedText}</i></span>
    </h1>
  );
}

export default AnimatedHeadline;
